export default __webpack_public_path__ + "static/calendar.dark-bed6719e9aa30336cbc9112479df496286fffbad44ca2444192bf729223f0341.png";